import { Toast } from 'bootstrap'

const error = document.getElementById('error');

if(error){
    new Toast(document.getElementById('error')).show()
}